<template>
  <div>
    <b-card title="Search by Vendor and Product" class="b-card-space">
      <b-row>
        <b-col cols='3' xl='4' lg='6' class='bold-gold'>
          {{ warning  }}
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="4" lg="6">
          <v-select v-model="selectedVendor"
                    placeholder="Select vendor please. Minimum 3 characters to search."
                    :options="vendors"
                    :filterable="false"
                    @search="onSearch"
                    @input="applySelectedVendor">
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.label }}
              </div>
            </template>
            <template slot="selected-option" slot-scope="option">
              <div class="selected d-center">
                {{ option.label }}
              </div>
            </template>
          </v-select>
          <p class="mt-2 font-italic" v-if="selectedVendor">
            You can only create Assignment Terms for this Partner in
            <a :href="selectedVendor.salesforceLink" target="_blank">
              Salesforce
            </a>
            via a Contract Term
          </p>
        </b-col>
        <b-col xl="4" lg="6">
          <v-select v-model="selectedProduct"
                    placeholder="Please choose product"
                    class="mb-3"
                    :options="productsForVendor"
                    :disabled="selectedVendor == null">
            <template slot="option" slot-scope="option">
              <div class="d-center">
                {{ option.label }}
              </div>
            </template>
          </v-select>
        </b-col>
        <b-col xl="4" lg="6">
          <b-btn @click="goToAssignmentTerms()"
                 :disabled="productAndVendorNotSelected()"
                 variant="success"
                 id="search">
            Search
          </b-btn>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>

import VendorProductSearchMixin from '@/mixins/VendorProductSearchMixin'

export default {
  name: 'Search',
  mixins: [VendorProductSearchMixin],
  components: {},
  methods: {
    goToAssignmentTerms () {
      this.$router.push({
        name: 'AssignmentTermsList',
        params: {
          vendorId: this.selectedVendor.id,
          productId: this.selectedProduct.id
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.v-select {
  font-family: 'Avenir', Helvetica, Arial, sans-serif
}

.bold-gold {
  color: #E8AF2E;
  font-weight: bold;
}

.b-card-space {
  margin-bottom: 10px;
  margin-top: 10px;
}
</style>
